import { Component, inject, OnInit } from '@angular/core';
import { SharedPeerToPeerConfirmationModule } from '@pages/send-money/components/peer-to-peer-confirmation/shared-peer-to-peer-confirmation.module';
import { SharedPeerToPeerConfirmationComponent } from '@pages/send-money/components/peer-to-peer-confirmation/shared-peer-to-peer-confirmation.component';
import { SpottiFacialVerificationComponent } from '../spotti-facial-verification/spotti-facial-verification.component';
import { PeerToPeerSuccessComponent } from '../peer-to-peer-success/peer-to-peer-success.component';
import { CustomersService } from '@lib/services/customer/customer.service';

@Component({
    standalone: true,
    selector: 'app-peer-to-peer-confirmation',
    templateUrl: './peer-to-peer-confirmation.component.html',
    styleUrls: ['./peer-to-peer-confirmation.component.scss'],
    imports: [SharedPeerToPeerConfirmationModule],
})
export class PeerToPeerConfirmationComponent extends SharedPeerToPeerConfirmationComponent implements OnInit {
    private customerService = inject(CustomersService);
    ngOnInit() {
        this.redirectToComponent = PeerToPeerSuccessComponent;
    }

    override confirmTransfer() {
        this.customerService.fetchCustomerDetailsById(this.userInfo.id).subscribe((customer) => {
            if (!customer.custom_info['sdk_verification_required'] || customer.custom_info['sdk_verification_required'] === 'false') {
                return super.confirmTransfer();
            }

            const dialogRef = this.sidePanel.open(SpottiFacialVerificationComponent, { data: { receiverId: this.transferResponse.receiver_user_id } });
            dialogRef.componentInstance.donePressed.subscribe((reportResult: 'clear' | 'consider') => {
                dialogRef.close();
                if (reportResult === 'clear') {
                    super.confirmTransfer();
                } else {
                    const errorDetails = {
                        title: 'Facial Verification failed',
                        message: 'We couldn’t identify your identity. Try again',
                    };
                    super.rejectTransfer(errorDetails);
                }
            });
        });
    }
}
